import server from '../request';
import encryptServer from '../request/encryptRequest';

// 查询 采购对账 列表(根据条件)
export const queryReconciliationList = (params = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/queryReconciliationList', params);
};

// 统计 采购对账 状态信息
export const queryStateInfo = (params = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/queryStateInfoBySupId', params);
};

// 修改采购对账状态
export const editReconciliationState = (params = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/editState', params);
};

// 查询 采购对账 详情(根据对账ID)
export const getDetailReconciliation = (params = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/queryById', params);
};

// 查询 冲销明细 (根据对账明细 ID)
export const getDetailReconciliationLists = (params = {}) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/queryWriteOffListById', params);
};

// 导出明细
export const exportTable = (params) => {
  return server.post('/xiaozi-xms/wireless/saas/reconciliation/excel', params, {
    responseType: 'blob',
  });
};

// 获取操作日志列表
export const getOperationLogLists = (params) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/purchLog/queryByPage', params);
};

// 新增日志（供应链中心）
export const AddOperationLog = (params) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/purchLog/add', params);
};

// 查询 开票信息 (根据对账ID)
export const getReconciliationInvoiceList = (params) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/reconciliationInvoiceList', params);
};

// 获取支付信息列表
export const getPaymentInformationLists = (params) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/viewOrderPayByOrderId', params);
};

// 查询 冲销明细 (根据对账明细 ID)
export const getWriteOffInformationList = (params) => {
  return encryptServer.post('/xiaozi-xms/wireless/saas/reconciliation/queryWriteOffInfoById', params);
};
